/* Footer-nieuwsbrief -> Klaviyo lijst "B | Mailing list NL" (start welkomstflow met 10%-code).
 * Vervangt de standaard Shopify-aanmelding van #footer-newsletter.
 */
(function () {
  if (window.__tbcFooterKlaviyo) return;
  window.__tbcFooterKlaviyo = true;

  var COMPANY_ID = 'WdRMvz';
  var LIST_ID = 'TVjBjY';
  var SOURCE = 'Footer nieuwsbrief';

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'footer-newsletter') return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"], button');
    var email = input ? input.value.trim() : '';
    var msg = form.querySelector('[data-klaviyo-msg]');
    if (!msg) {
      msg = document.createElement('p');
      msg.setAttribute('data-klaviyo-msg', '');
      msg.setAttribute('role', 'status');
      msg.style.marginTop = '8px';
      form.appendChild(msg);
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Vul een geldig e-mailadres in.';
      return;
    }
    if (btn) btn.disabled = true;
    msg.textContent = '';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: SOURCE,
            profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
          },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        if (input) input.value = '';
        msg.textContent = 'Gelukt! Check je inbox voor je 10% korting.';
        if (window.dataLayer) window.dataLayer.push({ event: 'newsletter_signup', signup_source: 'footer' });
      })
      .catch(function () {
        msg.textContent = 'Aanmelden lukte niet. Probeer het opnieuw.';
      })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);
})();
